<template>
  <div>
    <Menu
      mode="horizontal"
      :active-name="menu_name"
      @on-select="selectMenu"
      style="width: 100%"
    >
      <div
        v-for="(v, k) in menus"
        :key="k"
        style="display: inline-block"
        v-auth="v.auth"
      >
        <MenuItem
          :name="v.name"
          @click="v.onClick"
          v-show="v.show === true ? false : true"
        >
          <Badge
            :overflow-count="10000000"
            v-if="v.badge && v.badge.count"
            :count="v.badge.count"
            :offset="[18, -3]"
          >
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
        </MenuItem>
      </div>
    </Menu>
    <div class="service_box" id="printArea" style="page-break-before: always">
      <div class="service_title">{{ customerName }}核算报告</div>
      <div class="service_nav">
        <div class="service_nav_date noprint">
          <div class="service_nav_date_left">请选择日期：</div>
          <!-- <el-date-picker v-model="classesDate" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
            start-placeholder="开始日期" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束日期"
            :picker-options="pickerOptions" @change="onClassSesDate">
          </el-date-picker> -->
          <el-date-picker
            v-model="classesDate"
            type="month"
            placeholder="选择月份"
            :picker-options="pickerOptions"
            @change="onClassSesDate"
          >
          </el-date-picker>
          <div class="service_nav_date_left mode">模式:</div>
          <el-select v-model="type" placeholder="请选择" @change="ontype">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="service_nav_date_str">
          日期：{{ dayjsS(begin).format("YYYY日MM月DD日") }} -
          {{ dayjsS(end).format("YYYY日MM月DD日") }}
        </div>
        <div class="service_nav_right noprint">
          <div class="service_nav_right_email">
            <Button type="info" @click="handleShenpi"> 发送邮箱 </Button>
          </div>
          <div class="service_nav_right_print">
            <Button type="info" v-print="printObject" @click="handlePrint">
              打印
            </Button>
          </div>
          <div class="service_nav_right_email">
            <Button type="info" @click="onExport()"> 导出 </Button>
          </div>
        </div>
      </div>
      <div class="service_main">
        <el-table
          :data="tableData"
          style="width: 100%; min-height: calc(100vh - 500px)"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            align="center"
            label="序号"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="checkDeskName"
            label="核算科室"
            min-width="180"
          >
          </el-table-column>
          <el-table-column
            prop="facilityCount"
            align="center"
            label="设备数量(台)"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.facilityCount ? scope.row.facilityCount : 0 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="facilityInsertCount"
            align="center"
            label="新增(个)"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.facilityInsertCount
                    ? scope.row.facilityInsertCount
                    : 0
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consumableReceiveCount"
            align="center"
            label="耗材数量(个)"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.consumableReceiveCount
                    ? scope.row.consumableReceiveCount
                    : 0
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="money"
            align="center"
            label="金额"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.money ? scope.row.money.toFixed(2) : 0 }}元
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="type == 2 && !isPrinting"
            align="center"
            label="操作"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                <div
                  style="
                    color: #4991ff;
                    height: 24px;
                    padding: 0 7px;
                    font-size: 14px;
                    border-radius: 3px;
                    cursor: pointer;
                  "
                  @click="onDetails(scope.row)"
                >
                  详情
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import youxiangDesk from "./youxiangDesk.vue";
import config from "../../../config";
export default {
  components: {
    youxiangDesk,
  },
  data() {
    return {
      menu_name: "",
      menus: [
        {
          label: "成本",
          name: "Accountingreport",
          auth: "/admin/Accounting/main",
        },
        {
          label: "科室",
          name: "AccountingList",
          auth: "/admin/Accounting/main",
        },
        {
          label: "核算设置",
          name: "Accountinginstall",
          auth: "/admin/Accounting/main",
        },
      ],
      type: "1",
      options: [
        {
          value: "1",
          label: "耗材模式",
        },
        {
          value: "2",
          label: "按台模式",
        },
      ],
      tableData: [],
      list: [],
      classesDate: "",
      begin: "",
      end: "",
      customerName: "",
      loading: false,
      dayjsS: dayjs,
      printObject: {
        id: "printArea",
        popTitle: window.localStorage.getItem("customerName") + "核算报告",
        manualPageBreak: true,
      },
      pickerOptions: {
        disabledDate: (time) => {
          let current_time =
            dayjs(new Date()).format("YYYY-MM-DD ") + "23:59:59"; //时间日期为：‘当前日期 23:59:59’
          let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
          return time.getTime() > t;
        },
      },
      currentRequestId: 0,
      isPrinting: false,
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    let timeStr = window.localStorage.getItem("classesDateStr");

    if (timeStr) {
      window.localStorage.removeItem("classesDateStr");
      this.classesDate = timeStr;
      this.onClassSesDate(this.classesDate);
      this.type = "2";
    } else {
      this.classesDate = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD HH:mm:ss");
      this.begin = dayjs()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD HH:mm:ss");
      this.end = dayjs()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD HH:mm:ss");
      this.load();
    }

    this.customerName = window.localStorage.getItem("customerName");
  },

  methods: {
    handlePrint() {
      this.isPrinting = true; // 先隐藏操作列
      this.$nextTick(() => {
        // 打印窗口关闭后（无论打印/取消）恢复列
        // const onAfterPrint = () => {
        //   this.isPrinting = false;
        //   window.removeEventListener("afterprint", onAfterPrint);
        // };
        // window.addEventListener("afterprint", onAfterPrint);

        // 保险：3 秒后如果没触发 afterprint，也恢复
        setTimeout(() => {
          this.isPrinting = false;
          // window.removeEventListener("afterprint", onAfterPrint);
        }, 3000);
      });
    },
    onDetails(row) {
      console.log(row);
      console.log(this.classesDate);
      let dateStr = dayjs(this.classesDate).format("YYYY-MM-DD HH:mm:ss");
      window.localStorage.setItem("classesDateStr", dateStr);
      $utils.url.push({
        name: "accountingDetail",
        query: { checkDeskId: row.checkDeskId, month: dateStr },
      });
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    async load() {
      this.currentRequestId = (this.currentRequestId || 0) + 1;
      const requestId = this.currentRequestId;
      let q = {
        begin: this.begin,
        end: this.end,
        type: this.type,
      };
      this.loading = true;
      let res = await $utils.api.load(
        "/admin/system/check/checkReport",
        q,
        "get"
      );
      if (requestId !== this.currentRequestId) {
        return;
      }
      this.loading = false;
      if (res.code == 200) {
        document.title = `${this.customerName}${dayjs(this.begin).format(
          "YYYY年MM月"
        )}核算报告`;
        this.tableData = res.data;
        const totals = {
          checkDeskName: "总计",
          facilityCount: 0,
          facilityInsertCount: 0,
          consumableReceiveCount: 0,
          money: 0,
        };
        this.tableData.forEach((row) => {
          totals.facilityCount += row.facilityCount || 0;
          totals.facilityInsertCount += row.facilityInsertCount || 0;
          totals.consumableReceiveCount += row.consumableReceiveCount || 0;
          totals.money += row.money || 0;
        });
        this.tableData.unshift(totals);
      } else {
        this.tableData = [];
        this.$Modal.success({
          closable: true,
          title: "提示",
          width: "600px",
          height: "120px",
          okText: "取消",
          showOk: false,
          render: (h) => {
            return <h3>{res.msg}</h3>;
          },
        });
      }
    },
    async onExport() {
      let q = {
        begin: "",
        end: "",
        type: "",
      };
      q.begin = this.begin;
      q.end = this.end;
      q.type = this.type;
      this.loading = true;
      let res = await $utils.api.load(
        "/admin/system/check/implCountEmail",
        q,
        "get"
      );
      if (res.code == 200) {
        window.location.href =
          config.API_HOST + `/admin/common/download?fileName=${res.msg}`;
        this.loading = false;
      }
    },
    handleShenpi(row) {
      this.$Modal.success({
        closable: true,
        title: "发送至邮箱",
        width: "600px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <youxiangDesk
              begin={this.begin}
              end={this.end}
              type={this.type}
              onClose={() => this.onClose()}
            >
              {" "}
            </youxiangDesk>
          );
        },
      });
    },
    onClassSesDate(e) {
      const dayjs = require("dayjs");
      const inputDate = dayjs(e);
      const now = dayjs();
      let startOfMonth, endOfMonth;
      if (inputDate.isSame(now, "month")) {
        startOfMonth = inputDate.startOf("month");
        endOfMonth = now; // 当前时间
      } else {
        startOfMonth = inputDate.startOf("month");
        endOfMonth = inputDate.endOf("month");
      }
      this.begin = startOfMonth.format("YYYY-MM-DD HH:mm:ss");
      this.end = endOfMonth.format("YYYY-MM-DD HH:mm:ss");
      this.load();
    },
    ontype(e) {
      this.type = e;
      this.load();
    },
    indexMethod(index) {
      return index;
    },
  },
};
</script>

<style lang="less" media="print">
.service_box {
  // min-height: calc(100vh - 100px);

  .service_title {
    width: 100%;
    font-size: 28px;
    text-align: center;
    font-weight: 800;
  }

  .service_nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 20px 0;

    .service_nav_date {
      display: flex;
      align-items: center;
      width: 50%;

      .service_nav_date_left {
        margin-right: 10px;
      }

      .mode {
        margin-left: 10px;
      }

      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }

    .service_nav_date_str {
      display: none;
      font-size: 16px;
    }

    .service_nav_right {
      display: flex;
      width: 40%;
      justify-content: right;
      align-items: center;
      padding: 0 20px;

      .service_nav_right_print {
        font-size: 16px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }

  .el-table tr:nth-child(1) {
    background: #66d4ff;
    font-weight: 600;
  }
}

@page {
  size: auto;
  margin: 3mm;
}

@media print {
  html {
    background-color: #ffffff;
    height: auto !important;
    margin: 0px;
  }

  body {
    border: solid 1px #ffffff;
    margin: 10mm 15mm 10mm 15mm;
  }

  .noprint {
    display: none !important;
  }

  .service_nav_date_str {
    display: block !important;
  }

  #printArea {
    width: 100%;
    // height: 100vh !important;
    overflow: visible !important;
  }

  .service_main {
    width: 100%;
  }

  #printArea table {
    table-layout: auto !important;
  }

  #printArea .el-table tr:nth-child(1) {
    background: #66d4ff !important;
    font-weight: 600;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  // #printArea .el-table--enable-row-transition .el-table__body td.el-table__cell {
  //     background: #66d4ff !important;
  // }

  // #printArea .el-table {
  //     height: 100vh !important;
  // }

  #printArea .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  #printArea .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }

  #printArea #pagetable table {
    table-layout: fixed !important;
  }
}
</style>
